import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import * as globalConst from './../../../constants';

@Injectable()
export class BulkRenewalFlowService {

  private apiUrl = globalConst.baseAPI;  // URL para web api  

  constructor(private http: Http) { }

  getUsers() {
    return this.http
      .get(this.apiUrl + "/users/v1/getsimpleuserlist/", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getBulkRenewalFlows() {
    return this.http
      .get(this.apiUrl + "/flowlimitrenewal/v1/getlist?$filter=Ativo eq true&$orderby=Nivel asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  insertBulkRenewalFlow(bulkRenewalFlow) {

    var params = {
      "Nivel": bulkRenewalFlow.Nivel,
      "UsuarioId": bulkRenewalFlow.UserID,
      "Ativo": true,
    }

    return this.http
      .post(this.apiUrl + "/flowlimitrenewal/v1/insert", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  deleteBulkRenewalFlow(id) {
    return this.http
      .delete(this.apiUrl + 'flowlimitrenewal/v1/inactive/' + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/bulk-renewal-flow/service/bulk-renewal-flow.service.ts